export const postcodeRegex = /^\d{4}$/;

export const regexName = /^[A-Za-z ,.'-]*$/;

export const regexMobilePhone = /^04\d{2}\s?\d{3}\s?\d{3}$/;

export const regexAbn = /^\d{2} \d{3} \d{3} \d{3}$/;

export const SKU_REGEX = /^\d+$/;

/** Regex parsing all the properties of an Australian address */
/* eslint no-useless-escape: "off" */
export const ADDRESS_REGEX =
  /^\s*(?:(?:(?:(?<c_level_type>level|lvl|floor|flr)\s*(?<c_level_number>\w+),?\s*)?\s*,?\s*(?:(?<c_unit_type>[a-z][\w\-']*)?\s*)?(?:(?<c_unit_number>[\w\.]*(?!\d))\s*[,\/]*\s*)?(?<c_house_number>\d+[a-z]?(?:\s*[-\/,.:;?!]\s*\d+[a-z]?)*))?\s*,?\s*(?<c_street_name>[\w\-\s\'\ ]*)\s+\b(?<c_street_type>fire\s*track|right\s*of\s*way|service\s*way|shopping\s*centre|state\s*highway|\w{2,})\b\s*,?\s*(?<c_suburb>\w+(?:\s+\w+)*)?\s*(?:\n+(?<c_trailing>.+))?)$/gis;

export const STREET_REGEX =
  /^\s*(?<c_house_number>\d+[a-z]?(?:\s*[-,.:;?!]\s*\d+[a-z]?)*)?\s*,?\s*(?<c_street_name>[\w\-\s\'\ ]*)\s+\b(?<c_street_type>fire\s*track|right\s*of\s*way|service\s*way|shopping\s*centre|state\s*highway|\w{2,})\b\s*,?\s*(?<c_trailing>.*)$/gis;

export const EMAIL_REGEX = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;

export type AddressRegexMatch = {
  c_level_type?: string;
  c_level_number?: string;
  c_unit_type?: string;
  c_unit_number?: string;
  c_house_number?: string;
  c_street_name?: string;
  c_street_type?: string;
  c_suburb?: string;
  c_trailing?: string;
};

export type StreetRegexMatch = {
  c_house_number?: string;
  c_street_name?: string;
  c_street_type?: string;
  c_trailing?: string;
};

export const TZ_OFFSET_REGEX = /([+-]\d{2}):?(\d{2})$/;

/** Matches /account/purchases/{orderId} and captures orderId */
export const PURCHASES_PATH_REGEX = /\/account\/purchases\/([^/]+)/;

export const VALID_VIN_PATTERN = /^[A-HJ-NPR-Z0-9]{17}$/;

export const VALID_REGO_PATTERN = /^[A-Za-z0-9 ]+$/;